// extracted by mini-css-extract-plugin
export default {"Text":"iteration-diff-value-module__Text--zRzQT","Text_1":"iteration-diff-value-module__Text_1--qQK11","Text_2":"iteration-diff-value-module__Text_2--tee8n"};